globalThis.WorldThumbnail = class WorldThumbnail {
  constructor(doc) {
    this.canvas = document.createElement("canvas");
    const size = doc.getSize();
    this.canvas.style.transform = "scale(2)";
    this.canvas.width = size.x + 2;
    this.canvas.height = size.y + 2;
    this.context = this.canvas.getContext("2d");
    const base64 = globalThis.BASE64.split("");
    const rows = doc.data.split("\n");
    for (let y = 0; y < rows.length; y++) {
      const row = rows[y];
      for (let x = 0; x < row.length; x++) {
        const char = row[x];
        const index = base64.findIndex((c) => c === char);
        if (index === -1) this.context.fillStyle = "#888";
        else {
          const { passthrough, color } = globalThis.BLOCK_CONFIG[index] || {};
          this.context.fillStyle = color || (passthrough ? "#666" : "#000");
        }
        this.context.fillRect(x, y, 1, 1);
      }
    }
  }
};
